import React, { createContext, useState, useCallback, useMemo } from 'react';

export const PurchaseFlowStateContext = createContext();

const initialState = {
  isActive: false,
  stepKey: null,
  stepIndex: 0,
  selectedProduct: null,
  selectedProductPlan: null,
  requestedAmount: null,
  selectedOfferSummary: null
};

export const PurchaseFlowStateProvider = ({ children }) => {
  const [saleState, setSaleState] = useState(initialState);

  const startSaleMonitor = useCallback(() => {
    setSaleState({ ...initialState, isActive: true });
  }, []);

  const updateSaleMonitor = useCallback((partial) => {
    setSaleState(prev => ({ ...prev, ...partial }));
  }, []);

  const resetSaleMonitor = useCallback(() => {
    setSaleState(initialState);
  }, []);

  const value = useMemo(() => ({
    saleState,
    startSaleMonitor,
    updateSaleMonitor,
    resetSaleMonitor
  }), [saleState, startSaleMonitor, updateSaleMonitor, resetSaleMonitor]);

  return (
    <PurchaseFlowStateContext.Provider value={value}>
      {children}
    </PurchaseFlowStateContext.Provider>
  );
};
